/**
 * Generates a short, random ID for distinguishing model instances in logs.
 */
export const shortid = () => {
    return Math.random().toString(36).slice(2, 8);
};
